/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import Loading from 'quasar/src/plugins/Loading.js';;
import http from '../http/http';
import { success, error } from '../../../services/alert-message';

const urlApi = 'v1/dominios';

/**
*
* @param {*} param0
*/
export async function dominioList({ commit }, obj) {
  return (await http.get(`${urlApi}/search?${obj.filter}`)
    .then(res => {
      commit('SET_DOMINIOS', res.data);
      return res;
    })
    .catch(err => {
      return err;
    })
  ).data;
}

/**
*
* @param {*} param0
*/
export async function dominioSave({ commit }, obj) {
  Loading.show();
  return (await http.post(`${urlApi}`, obj)
    .then(res => {
      Loading.hide();
      success(res.data.message);
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}
